// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ActionsPopover from '../../../shared/components/actions-popover';
import AffectedPin from '@deere/cps-it.warranty-model-factory/lib/affected-pin';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledString from '../../../shared/components/labeled-string';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDealer} from '../../../shared/services/build-dealer';
import {getPipActions} from '../../shared/services/pip-actions';

const PipAffectedPinDetails = (props, context) => {

    const actionList = getPipActions(context, props.pin, props.pipId);

    return (
        <div className='affected-pin-details'>
            <div className='row'>
                <LabeledString
                    className='lost-two-column'
                    data={buildDealer(props.pin.dealer)}
                    label='DEALER'
                />
                <LabeledString
                    data={props.pin.model}
                    label='MODEL'
                />
            </div>
            <div className='row'>
                <LabeledNode
                    className='lost-two-column'
                    data={props.pin.customerSummary.displayName}
                    label='CUSTOMER'
                />
            </div>
            {actionList.length > 0 &&
                <footer>
                    <ActionsPopover options={actionList}/>
                </footer>
            }
        </div>
    );

};

PipAffectedPinDetails.displayName = 'PipAffectedPinDetails';
PipAffectedPinDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    pin: PropTypes.instanceOf(AffectedPin).isRequired,
    pipId: PropTypes.string.isRequired
};
PipAffectedPinDetails.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default PipAffectedPinDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-details/components/pip-affected-pin-details.js